export const errorMessages: Record<
	string,
	{ description: string; heading: string }
> = {
	required: {
		heading: "* Required Field",
		description: "There are incomplete required fields. Please complete them.",
	},
	403: {
		heading: "Invalid Credentials",
		description: "Email or Password does not match with existing records.",
	},
	422: {
		heading: "Validation Error",
		description: null,
	},
	429: {
		heading: "Too Many Login Attempts.",
		description:
			"Your account has been suspended, please try again with the right credentials in 3 mins",
	},
	connection: {
		heading: "Connection not established",
		description: "Unable to process your request",
	},
	invalid: {
		heading: "Invalid Request",
		description: "Unable to process your request",
	},
};
